import React from "react";

import inconnu from "./assets/icons/inconnu.png"
import simpleuser from "./assets/icons/simpleuser.png"
import Button from "../../../../components/bases/button/button";

import Tooltip from "../../../../components/bases/tooltips/tooltip";
import getText from "../../../../utils/language.js"
import LoginEditUser from "./loginedituser.js";


import { GlobalContext } from '../../../../utils/globalprovider';

import { GetCurrentUserOptions, SetCurrentUserDisplayTasks } from "../../../../utils/software";
import { apiSaveUserOptions } from "../../../../utils/apis.js";

import deconnect from "./assets/icons/deconnect.png"
import edituser from "./assets/icons/edituser.png"
import local from "./assets/icons/local.png"
import notification from "./assets/icons/notification.png"





import './styles.css';
import { getCurrentUserDatas, setCurrentUserDatas } from "../../../../utils/software";





class Login extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)

        
        this.state =
        {
                displayPopup: false,
                displayModif: false,
                userdatas: getCurrentUserDatas().datas,
        }


        

        this.gereBouton = this.gereBouton.bind(this)
        this.onfinishedit = this.onfinishedit.bind(this)
    }


    gereBouton(datas)
    {
        switch (datas)
        {
                case "modif":
                    this.setState(
                        {
                            displayPopup: false,
                            displayModif: true,
                        })
                    break;
                case "deconnect":
                    if (this.props.onnavigate)
                    {
                        const userdatas = getCurrentUserDatas();
                        userdatas.id = 0;
                        setCurrentUserDatas(userdatas);                        
                        this.props.onnavigate("logout")
                    }
                    break;
                case "local":
                    if (this.props.onnavigate)
                        this.props.onnavigate("local")
                    break;
                case "notification":
                    SetCurrentUserDisplayTasks(true) ; // on ecrit dans 
                    const datas = GetCurrentUserOptions();
                    apiSaveUserOptions(datas, null);
                    break;
    
                }
    }

    onfinishedit(datas)
    {
        
        if (datas)
        {



            var dataUser = getCurrentUserDatas()
            dataUser.datas.lastname = datas.lastname
            dataUser.datas.firstname = datas.firstname
            dataUser.datas.phone = datas.phone
            dataUser.datas.email = datas.email
            dataUser.datas.image  = datas.image
            setCurrentUserDatas(dataUser)

        }
            
        this.setState(
            {
                displayPopup: false,
                displayModif: false,
                userdatas: getCurrentUserDatas().datas,
            })
        
        
    }

    displayBoutonEmissions(displayIt)
    {
        if(!displayIt) return (null)
        return (<span>
    
        </span>

        )
    }

    displayModifUser()
    {
        
        if (this.state.displayModif)
        {
            return(<LoginEditUser {...this.props} onfinish={this.onfinishedit}/>)
        }   
        else
            return (null)
        
    }

    displayPopup()  
    {


        if (!this.state.displayPopup) return (null)

        var lastname="?"
        var firstname=""
        var email=""
        var image=""
        var id=0;
     
        try{

         

            id= this.state.userdatas.id
            lastname= this.state.userdatas.lastname
            firstname= this.state.userdatas.firstname
            email= this.state.userdatas.email
            image= this.state.userdatas.image 
            
    
        }
        catch(e)
        {
            id=0;
        }

        if (id== 0)return (null)

            var textbutton1 = getText(9,0, this.context.language);
            var textbutton2 = getText(9,1, this.context.language);
            var textbutton3 = getText(9,2, this.context.language);
            var textbutton4 = "Notifications";

            
        return(
            <>
            <div className="login-datas"
                
                onMouseEnter={this.onImgMouseEnter.bind(this)}
                onMouseLeave={this.onImgMouseLeave.bind(this)}
        
            >
               
                <div className = "login-datas-text">{email}</div>
               
                
          


                <div className = "login-datas-button">

                <span>
                    <Tooltip text={textbutton1}>
                    <Button 
                        width="32" height="32" 
                        image={deconnect} 
                        disable={false}
                        datas="deconnect"
                        onClick={this.gereBouton}
                    />
                    </Tooltip>
                </span>
                &nbsp;&nbsp;
                <span>
                <Tooltip text={textbutton2}>
                    <Button
                        width="32" height="32" 
                        image={edituser} 
                        disable={false}
                        datas="modif"
                        onClick={this.gereBouton}
                    />
                    </Tooltip>
                </span>

                &nbsp;&nbsp;
                
                <span>
                <Tooltip text={textbutton3}>
                    <Button
                        width="32" height="32" 
                        image={local} 
                        disable={false}
                        datas="local"
                        onClick={this.gereBouton}
                    />
                    </Tooltip>
                </span>

                &nbsp;&nbsp;
                
                <span>
                <Tooltip text={textbutton4}>
                    <Button
                        width="32" height="32" 
                        image={notification} 
                        disable={false}
                        datas="notification"
                        onClick={this.gereBouton}
                    />
                    </Tooltip>
                </span>

            </div>
            <div className = "login-datas-text">{firstname+" "+lastname}</div>
            </div>
            
            </>

        )
    }

    onImgMouseEnter()
    {
        
        this.setState( {displayPopup:true})
    }

    onImgMouseLeave()
    {
        
        this.setState( {displayPopup:false})
    }

    
    displayImageUser(id,image)
    {

        const imgsize = 32;
        
        if (id == 0)
        {
            return (
                <>
                    <img image={inconnu} width={imgsize} height={imgsize} 
                    onMouseEnter={this.onImgMouseEnter.bind(this)}
                    onMouseLeave={this.onImgMouseLeave.bind(this)}/>
                </>
            )
        }
        if ((image==null ) || (image.length < 5))
        {
            const filter= {filter:localStorage.getItem("default-icon-filter")};
            return (
                <img src={simpleuser} width={imgsize} height={imgsize} style={filter}
                onMouseEnter={this.onImgMouseEnter.bind(this)}
                onMouseLeave={this.onImgMouseLeave.bind(this)}/>
            
            )
        }
        var style = getComputedStyle(document.body)
    
        // set language code
        var bordercolor = style.getPropertyValue('--default-icon-color');
    
        var imgstyles = 
        {
            marginLeft:"5px",
            borderStyle:"solid",
            borderWidth:"3px",
            borderColor:bordercolor,
            borderRadius:"34px",
        }


        return(
        <img src={image} width={64} height={64} 
                className = "login-image-user"
                style= {imgstyles}
                onMouseEnter={this.onImgMouseEnter.bind(this)}
                onMouseLeave={this.onImgMouseLeave.bind(this)}/>
        )

    
    }

    render()
    {
        var displayName = "Connectez-vous";
        var id = 0;
        var image= null;
        try
        {
            
            var id = this.state.userdatas.id;
            var image= this.state.userdatas.image;            
            
        }
        catch(e)
        {
            console.log("???")
        }
        
        return (
            <>
            <span>
            <div className="login-div">
            {this.displayImageUser(id,image)}
            <span className="login-name">{this.state.userdatas.firstname}</span>
            </div>

            {this.displayPopup()}
            </span>
            {this.displayModifUser()}
            </>
        )
    }

}

export default Login

